import {useService} from '@cindedi/react-application';
import {abort} from '@cindedi/request-utilities/abort';
import {H1} from '@cindedi/ui/components/Heading/H1';
import {isRecord} from '@cindedi/utilities/isRecord';
import {truncate} from '@cindedi/utilities/truncate';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';

export interface Membros$SlugLoaderData {
  member: Organization.PublicMemberDto;
}

export const meta: MetaFunction = function Membros$SlugMeta({data}) {
  return isRecord(data) && data.member
    ? [
        {title: `${data.member.name} | Cindedi`},
        {name: 'description', content: truncate(data.member.textDescription, 155)},
      ]
    : [{title: 'Membro - Cindedi'}];
};

export const loader: LoaderFunction = async function Membros$SlugLoader({context: {use}, params}) {
  const Member = use('Member');
  const {slug} = params;

  if (!slug) return abort(404);

  const member = await Member.find({where: {slug}});

  if (member == null) return abort(404);

  return json({member});
};

export default function Membros$SlugView() {
  const {member} = useLoaderData<Membros$SlugLoaderData>();
  useService('organization/titlebar').hide();

  return (
    <PublicLayout>
      <div className="flex gap-4 items-end mb-6 mt-2 lg:mt-0">
        <div
          aria-label={member.name}
          className="h-40 w-40 rounded bg-cover bg-no-repeat bg-center bg-shade-2"
          style={{backgroundImage: `url(${member.cover.url})`}}
        />
        <div className="flex flex-col w-full gap-4">
          <H1 size="md">{member.name}</H1>
          <div className="w-full flex gap-2 text-primary-8 text-sm items-center bg-primary-1 p-4 rounded">
            <span>{member.position.name}</span>•
            <Link to={member.curriculum} target="_blank">
              Curriculum vitae
            </Link>
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{__html: member.description}} />
    </PublicLayout>
  );
}
